import './services-content.scss'

export const component = {
    name: 'services-content',

    data: {
        tabsIndex: 0
    },

    computed: {
        currentTab() {
            return this.tabs[this.tabsIndex]
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/services-content/services-content.js